import { ReactNode } from 'react';
import { IChildrenProp } from 'types/components/components.interface';
import './LabelFormStep.scss';

interface ILabelFormStepProps extends IChildrenProp {
  header: ReactNode;
  description: ReactNode;
}

const LabelFormStep = ({
  header,
  description,
  children,
}: ILabelFormStepProps) => {
  return (
    <div className='label-form-step'>
      <div className='label-form-step-header'>{header}</div>
      <div className='label-form-step-description'>{description}</div>
      <div className='label-form-step-content'>{children}</div>
    </div>
  );
};

export default LabelFormStep;
